import React, {memo} from 'react'
import {Tab} from 'semantic-ui-react'
import {withHelmet, withErrorHandling, withMeData, withPropsPresent} from '../../hoc'
import {userIsAdmin, withInheritedProps} from '../../util'

const _Profile = (props) => {
  const {
    isAdmin,
    tabIndex,
    navigate,
    basePath = '/c/account',
    children
  } = props

  const onTabSelected = async (tabIndex) => {
    let path = 'profile'
    if (tabIndex === 1) {
      path = 'accounts'
    }
    if (tabIndex === 2) {
      path = 'change-password'
    }
    if (tabIndex === 3) {
      path = 'close-account'
    }
    navigate(`${basePath}/${path}`)
  }

  const panes = [
    {menuItem: 'Profile'},
    {menuItem: 'Accounts'},
    {menuItem: 'Change Password'}
  ]
  if (isAdmin) {
    panes.push({menuItem: 'Close Account'})
  }
  return (
    <div data-testid='profile-container'>
      <Tab activeIndex={tabIndex} onTabChange={(e, data) => onTabSelected(data.activeIndex)} panes={panes.map(p => {
        return {
          ...p,
          render: () => (
            <Tab.Pane>
              {
                withInheritedProps(children, props)
              }
            </Tab.Pane>
          )
        }
      })}/>
    </div>
  )
}

let Profile = (props) => {
  const isAdmin = userIsAdmin(props.me)
  const {location} = props
  let tabIndex = 0
  if (location.pathname.indexOf('accounts') > -1) {
    tabIndex = 1
  }
  if (location.pathname.indexOf('change-password') > -1) {
    tabIndex = 2
  }
  if (location.pathname.indexOf('close-account') > -1) {
    tabIndex = 3
  }
  props = {...props, tabIndex, isAdmin}
  return (<_Profile {...props}/>)
}

Profile = withHelmet(Profile, 'Profile')
Profile = withPropsPresent(Profile, ['me'])
Profile = withMeData(Profile, 'Loading profile...')
Profile = withErrorHandling(Profile)
Profile = memo(Profile)

export {Profile, _Profile}

export default Profile